import { Model } from '@vuex-orm/core';

export default class Karte extends Model {
  static entity = 'karte';
  static primaryKey = 'id';

  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {number} */
    this.id;
    /** @type {string} */
    this.title;
    /** @type {string} */
    this.stylejson;
    /** @type {string} */
    this.legendUrl;
    /** @type {boolean} */
    this.adminsOnly;
  }

  static fields() {
    return {
      id: this.number(0),
      title: this.string(''),
      stylejson: this.string(''),
      legendUrl: this.string(''),
      adminsOnly: this.boolean(false)
    };
  }
}
